import { createFileRoute } from '@tanstack/react-router';

import End from '~/end/End';

export const Route = createFileRoute('/results')({
  component: End,
});
